/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : STATUS : STYLES --------------- ++++++++++ */
export default theme => ({
	status: {
		borderRadius: pxToEm(3),
		cursor: 'pointer',
		height: pxToEm(29),
		width: pxToEm(63),
		display: 'inline-flex',
		justifyContent: 'center',
		alignContent: 'center',
		alignItems: 'center',
		textAlign: 'center',
		transition: 'filter .2s linear 0s',
		'& .text': {
			color: theme.color.light.light.swatch,
			extend: theme.typography.size.xsmall
		},
		// types
		'&.online': { 
			background: theme.color.secondary.medium.swatch,
			'&.selected-false': { background: theme.color.neutral.medium.swatch }
		},
		'&.offline': { 
			background: theme.color.attention.dark.swatch,
			'&.selected-false': { background: theme.color.neutral.medium.swatch }
		},
		'&.selected-null': {
			cursor: 'default',
			'&:hover': { filter: 'none' }
		},
		// variant
		'&.variant-dot': {
			borderRadius: '100%',
			width: pxToEm(12),
			height: pxToEm(12),
			'& .text': { display: 'none' }
		},
		// states
		'&:hover': {
			filter: 'brightness(85%)'
		}
	}
});
